import React, { useState, useCallback, useRef, useEffect } from 'react';
import sendDirectFile from 'services/participant-indication/importDirectFile';
import forceDownload from 'services/storage/getUrlToForceDownload';
import FinishModal from 'components/ParticipantIndication/Modals/FinishImport';

import { useAuth } from 'context/AuthContext';
import { useToast } from 'context/ToastContext';
import { Container, SaveButton } from './styles';

interface Props {
  urlListSubsdiary: string;
}
const ImportFile: React.FC<Props> = ({ urlListSubsdiary }) => {
  const { participant } = useAuth();
  const [loading, setLoading] = useState(false);
  const [attachingFile, setAttachingFile] = useState(false);
  const [fileUrl, setFileUrl] = useState('');
  const inputFileRef = useRef<HTMLInputElement>(null);
  const [downloadLink, setDownloadLink] = useState('');
  const [modalOpened, setModalOpened] = useState(false);
  const [importedLines, setImportedLines] = useState(0);
  const [errors, setErrors] = useState<string[]>([]);
  const { simulating } = useAuth();
  const { addToast } = useToast();

  useEffect(() => {
  const isFocalPoint = participant?.profile.toString() === 'FOCALPOINT';
  setDownloadLink(
    forceDownload({
      filename: 'Indicação_participante_em_lote_modelo.xlsx',
      url: isFocalPoint
        ? 'https://storage.vendavall.com.br/photos/1748439603.68371233a156e4.63732889.xlsx'
        : 'https://storage.vendavall.com.br/photos/1741702074.67d043ba6bf714.14188759.xlsx',
    }),
  );
}, [participant]);

  const handleAttachFile = useCallback(
    async (e: React.ChangeEvent<HTMLInputElement>) => {
      if (e && e.target && e.target.files && e.target.files.length > 0) {
        setAttachingFile(true);
        const file = e.target.files[0];
        setFileUrl(file.name); // Apenas atualizando o nome do arquivo
        setAttachingFile(false);
      }
    },
    [],
  );

  const handleImport = useCallback(async () => {
    if (simulating) {
      addToast({ type: 'error', title: 'Operação não permitida' });
      return;
    }

    if (!inputFileRef.current?.files?.[0]) {
      addToast({ type: 'error', title: 'Selecione um arquivo antes de enviar.' });
      return;
    }
    setLoading(true);
    const formData = new FormData();
    formData.append('file', inputFileRef.current.files[0]);
    const result = await sendDirectFile(formData);
    setImportedLines(result.success_count);
    setErrors(result.errors);
    setLoading(false);
    setModalOpened(true);
  }, [addToast, simulating]);

  return (
    <Container>
      <h3>Em lote</h3>
      <h5>Limite máximo de 100 nomes por planilha/upload.</h5>
      <a href={downloadLink} download>
        Download da planilha de exemplo
      </a>

      <a href={urlListSubsdiary} className="icon-download" download>
        Download da lista de filiais
      </a>

      <label htmlFor="fileId">
        <input
          type="file"
          id="fileId"
          accept=".xlsx, .xls"
          onChange={handleAttachFile}
          ref={inputFileRef}
        />
        <button
          type="button"
          onClick={() => {
            inputFileRef.current?.click();
          }}
        >
        {attachingFile
           ? 'Carregando ... '
           : fileUrl
           ? 'Planilha selecionada'
           : 'Escolher planilha para Importar'}
        </button>
      </label>
      <SaveButton
        buttonRole="secondary"
        type="button"
        loading={loading}
        disabled={fileUrl === ''}
        onClick={handleImport}
      >
        Enviar
      </SaveButton>
      <FinishModal
        isOpen={modalOpened}
        onRequestClose={() => setModalOpened(false)}
        importedLines={importedLines}
        errors={errors}
      />
    </Container>
  );
};

export default ImportFile;